module.exports = __webpack_public_path__ + "static/media/vehicle_driverslicense.4d25f68b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/vehicle_driverslicense.pdf
// module id = 2163
// module chunks = 0